import React, { useEffect, useState } from 'react'
import ResourceService from '@services/resource.service'
import { RCard, RCardBody } from '@components/card'
import { RLoadingData } from '@components/loading'
import { RDataTable } from '@components/table'
import { rupiahTextHalfConvert } from '@hooks/convert'
import columns from './columns'

const Request = () => {
    const url = "/listing-verifikasi"
    const paginate = 10

    const [data, setData] = useState([]);
    const [result, setResult] = useState(null);

    // Tambahkan state filter (default kosong agar backend pakai default 1 bulan terakhir)
    const [filter, setFilter] = useState({
        start_date: '',
        end_date: ''
    });

    const [table, setTable] = useState({
        url: url,
        params: {
            paginate: paginate,
            search: '',
            // Masukkan filter ke dalam params
            start_date: '',
            end_date: ''
        },
        attr: {},
        default: {
            url: url,
            paginate: paginate,
        }
    });

    useEffect(() => {
        let mounted = true;
        const getData = () => {
            // Set result ke null agar loading muncul saat ganti tanggal/search
            setResult(null);

            ResourceService.table(table.url, table.params)
            .then(
                ({ data, ...res }) => {
                    if (mounted) {
                        let newData = [];
                        const { data: getData, ...attrs } = data

                        getData.map((nd) => {
                            newData.push({
                                ...nd,
                                harga: "Rp. "+rupiahTextHalfConvert(nd.harga?.toString() || "0")
                            })
                        })

                        setTable(prev => ({
                            ...prev,
                            attr: { ...prev.attr, ...attrs }
                        }))
                        setData(newData)
                        setResult(res)
                    }
                },
                (error) => {
                    if (mounted) {
                        setResult(error)
                    }
                }
            )
        }
        getData()
        return () => { mounted = false }
    }, [table.url, table.params, table.refresh]) // Trigger re-run saat params berubah

    // Fungsi untuk handle perubahan filter tanggal
    const handleFilterDate = (e) => {
        const { name, value } = e.target;
        setTable(prev => ({
            ...prev,
            params: {
                ...prev.params,
                [name]: value
            }
        }));
    };

    return (
        <RCard>
            <RCardBody>
                {/* Bagian Input Filter Tanggal */}
                <div className="row mb-4">
                    <div className="col-md-3">
                        <label className="form-label">Dari Tanggal:</label>
                        <input
                            type="date"
                            className="form-control"
                            name="start_date"
                            onChange={handleFilterDate}
                        />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Sampai Tanggal:</label>
                        <input
                            type="date"
                            className="form-control"
                            name="end_date"
                            onChange={handleFilterDate}
                        />
                    </div>
                </div>

                <RLoadingData result={result}>
                    <RDataTable
                        columns={columns}
                        data={data}
                        table={table}
                        setTable={setTable}
                    />
                </RLoadingData>
            </RCardBody>
        </RCard>
    )
}

export default Request
